module.exports = __webpack_public_path__ + "img/google-pay.22efe40.svg";